/**
 * RTL Layout Management Module
 * Manages HTML root element dir attribute based on current locale.
 */

const RTL_LOCALES = ['ar'];

/**
 * 判断指定 locale 是否为 RTL 语言
 * @param {string} locale
 * @returns {boolean}
 */
export function isRTLLocale(locale) {
    return RTL_LOCALES.includes(locale);
}

/**
 * 应用/移除 RTL 方向
 * @param {boolean} isRTL
 */
export function applyRTLDirection(isRTL) {
    const html = document.documentElement;
    if (isRTL) {
        html.setAttribute('dir', 'rtl');
    } else {
        html.setAttribute('dir', 'ltr');
    }
}

/**
 * 初始化 RTL 支持
 * 设置初始 dir 属性，并监听 i18n locale 变化动态更新
 * @param {VueI18n} i18n - vue-i18n 实例
 */
export function initRTL(i18n) {
    // 立即设置初始方向（在 Vue 挂载前）
    applyRTLDirection(isRTLLocale(i18n.locale));

    // 监听 locale 变化，动态更新 dir
    i18n._vm.$watch('locale', (newLocale) => {
        applyRTLDirection(isRTLLocale(newLocale));
    });
}
